import Vue from 'vue'
import queryString from 'query-string'
import { Users } from '@/services/api'
import jwx from "jsonwebtoken"

export default {
  state: {
    jwt: null,
  },
  getters: {
    login: state => {
      try {
        return jwx.decode(state.jwt).login
      } catch {
        return null
      }
    },
    authenticated: state => state.jwt !== null,
    roles: state => {
      try {
        return jwx.decode(state.jwt).roles
      } catch {
        return null
      }
    },
  },
  mutations: {
    authenticated(state, data) {
      state.jwt = data.jwt
    },
    logout(state) {
      state.jwt = null
    },
  },
  actions: {
    async logout({commit}) {
      await Vue.prototype.$auth.logout({
        postLogoutRedirectUri: `${window.location.origin}/login`,
        // Temporarily prevent access token revoking to work around a bug:
        // https://github.com/okta/okta-auth-js/issues/496
        revokeAccessToken: false,
      })
      commit('logout')
    },
    async handleAuthentication({commit, getters}) {
      // if we are in a development/QA environment, check the state param from the queryHash and redirect to the feature deployment callback
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'qa') {
        const parsedHash = queryString.parse(location.hash)
        try {
          const state = JSON.parse(atob(parsedHash.state))
          if (state.origin !== location.origin) {
            console.log(`state param found, redirecting to ${state.origin}`)
            location.assign(`${state.origin}/implicit/callback${location.hash}`)
            return
          }
        } catch (error) {
          console.log('Unable to process state param, ignoring', error)
        }
      }

      // store the okta id and access tokens in local storage
      await Vue.prototype.$auth.handleAuthentication()

      const memberInfo = await Users.memberInfo()

      commit('authenticated', {jwt: memberInfo.memberJwt})
      Vue.prototype.$ga.set("userId", getters.login)
    },
    async handleSSO() {
      await Vue.prototype.$auth.loginRedirect('/')
    },
  },
}
